import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { comparisonArticle } from '@/mocks/articleData';

export default function ComparisonArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={comparisonArticle} />
      <Footer />
    </>
  );
}